import React, { useContext, useEffect, useRef, useState } from "react";
import Context from "../../Context/Context";
import axios from "../axios/axios";
import { useNavigate } from "react-router-dom";

const avaliacaoStatus = ["Prejudicado", "Correção", "Realizado", "Concluído"];
const captacaoStatus = ["Enviado", "Rejeitado", "Concluído"];

function SolicitacaoesCaptacaoAvaliacao({
  solicitacaoToEdit,
  setSolicitacaoToEdit,
  isEditing,
  setIsEditing,
  setSolicitacoesCaptacaoAvaliacao,
  solicitacoesCaptacaoAvaliacao,
  page
}) {
  // fazer a logica feita em captacaoForm do "cache"
  const { usuario, indicacao, setIndicacao } = useContext(Context);
  const [formData, setFormData] = useState({
    diretorio: "",
    vara: "",
    foro: "",
    juizo: "",
    dataSolicitacao: "",
    nomeSolicitante: '',
    documentoSolicitante: '',
    enderecoSolicitante: '',
    advogado: "",
    tipoBem: "",
    estado: "",
    prioridade: "",
    dataConclusao: "",
    processo: "",
    status: !isEditing ? "Pendente" : "",
    solicitante_id: usuario.id,
    departamento_id: "",
    tipoSolicitacao: "",
    responsavel_id: "",
    setor_id: "",
    celula_id: "3",
    motivo_rejeicao: "",
    justificativa_avaliacao: "",
    dadosDoImovel: "",
    cartorio: "",
    num_matricula: "",
    link_relatorio: "",
    relatorios_gerados: ""
  });
  const nav = useNavigate();

  const [dataPrevista, setDataPrevista] = useState(false);
  const [focus, setFocus] = useState(true);
  const dataPrevistaRef = useRef(null);
  const [foundIndicacao, setFoundIndicacao] = useState(null)

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormData({
      ...formData,
      [name]: type === "file" ? e.target.files : value,
    });
  };

  const calcularDataConclusao = (prioridade, estado, dataBase) => {
    const diasPorPrioridade = {
      "São Paulo": { 1: 5, 2: 7, 3: 9, 4: 11 },
      Outros: { 1: 7, 2: 11 },
    };
    const dias = diasPorPrioridade[estado]?.[prioridade];
    if (!dias) return null;
    const dataInicial = dataBase ? new Date(dataBase) : new Date(); // Usa a dataBase ou o dia de hoje
    let diasUteis = 0;
    let dataConclusao = new Date(dataInicial);
    while (diasUteis < dias) {
      dataConclusao.setDate(dataConclusao.getDate() + 1);
      const diaSemana = dataConclusao.getDay();
      if (diaSemana !== 0 && diaSemana !== 6) {
        diasUteis++; // Ignorar domingos (0) e sábados (6)
      }
    }
    // Formatar a data no formato DD/MM/YYYY
    const dia = String(dataConclusao.getDate()).padStart(2, "0");
    const mes = String(dataConclusao.getMonth() + 1).padStart(2, "0");
    const ano = dataConclusao.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };
  // Atualizar a data de conclusão automaticamente
  useEffect(() => {
    if (formData.estado && formData.prioridade && formData.dataSolicitacao) {
      const dataConclusao = calcularDataConclusao(
        formData.prioridade,
        formData.estado,
        formData.dataSolicitacao, // Passa a dataSolicitacao como base
      );
      setFormData((prev) => ({ ...prev, dataConclusao }));
    }
  }, [formData.estado, formData.prioridade, formData.dataSolicitacao]);

  const treatData = (data) => {
    if (data.includes("T")) return data;
    return new Date(data + " ").toISOString();
  };

  const convertIsoData = (data) => {
    return data?.split("T")[0];
  };

  const resetForm = () => {
    setFormData({
      diretorio: "",
      vara: "",
      foro: "",
      juizo: "",
      dataSolicitacao: "",
      nomeSolicitante: '',
      documentoSolicitante: '',
      enderecoSolicitante: '',
      advogado: "",
      tipoBem: "",
      estado: "",
      prioridade: "",
      dataConclusao: "",
      processo: "",
      status: !isEditing ? "Pendente" : "",
      solicitante_id: usuario.id,
      departamento_id: "",
      tipoSolicitacao: "",
      responsavel_id: "",
      setor_id: "",
      celula_id: "3",
      motivo_rejeicao: "",
      justificativa_avaliacao: "",
      num_matricula: "",
      dadosDoImovel: "",
      cartorio: "",
      link_relatorio: ""
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData["celula_id"] != 3) {
      return alert("Em construção");
    }
    delete formData["celula_id"];
    if (formData["dataSolicitacao"])
      formData["dataSolicitacao"] = treatData(formData["dataSolicitacao"]);
    if (formData["dataConclusao"])
      formData["dataConclusao"] = treatData(
        formData["dataConclusao"]?.split("/").reverse().join("-"),
      );
    if (formData['dadosDoImovel']) {
      formData['dadosDoImovel'] = JSON.stringify(formData.dadosDoImovel)
    }
    const filteredData = {};
    Object.keys(formData).forEach((key) => {
      if (formData[key]) {
        if (key.includes("_id")) filteredData[key] = +formData[key];
        else filteredData[key] = formData[key];
      }
    });
    delete filteredData['responsavel_id']
    filteredData['indicacao_id'] = foundIndicacao?.id
    const { data } = await axios.post(
      "/solicitacao/captacao/avaliacao",
      filteredData,
    );
    resetForm();
    alert("Solicitacão criada com sucesso");
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    const filteredData = {};
    Object.keys(formData).forEach((key) => {
      if (formData[key]) {
        if (key.includes("_id")) filteredData[key] = +formData[key];
        else filteredData[key] = formData[key];
      }
    });

    if (
      usuario.role.includes("Captação") &&
      !captacaoStatus.includes(filteredData.status)
    ) {
      alert("Sem autorização");
    }

    if (
      usuario.role.includes("Avaliação") &&
      !avaliacaoStatus.includes(filteredData.status)
    ) {
      alert("Sem autorização");
    }

    if (formData["dataSolicitacao"])
      filteredData["dataSolicitacao"] = treatData(formData["dataSolicitacao"]);
    if (formData["dataConclusao"])
      filteredData["dataConclusao"] = treatData(
        formData["dataConclusao"]?.split("/").reverse().join("-"),
      );

    delete filteredData["responsavel"];
    delete filteredData["solicitante_id"];
    delete filteredData["responsavel_id"];
    delete filteredData["celula_id"];

    const { data } = await axios.put(
      "/solicitacao/captacao/avaliacao/" + solicitacaoToEdit.id,
      filteredData,
      {
        headers: { Authorization: usuario.token },
      },
    );

    setSolicitacoesCaptacaoAvaliacao(
      solicitacoesCaptacaoAvaliacao.map((e) =>
        e.id == solicitacaoToEdit.id ? { ...e, ...data[0] } : e,
      ),
    );

    if (filteredData.status == 'Concluído') {
      setIndicacao((prevIndicacao) => {
        // const filtradas = prevIndicacao.filter((e) => e.id !== id);
        // return [...filtradas, data];
        const index = prevIndicacao.findIndex((e) => e.id == +data[1]?.id); // nao tem found pegue o atraves do processo
        return [
          ...prevIndicacao.slice(0, index),
          data[1],
          ...prevIndicacao.slice(index + 1),
        ];
      });
    }


    setIsEditing(false);
    setSolicitacaoToEdit(false);
    resetForm();
    alert("Solicitação editada com sucesso");
  };

  useEffect(() => {
    if (isEditing) {
      setFormData({
        ...formData,
        ...solicitacaoToEdit,
        dataSolicitacao: convertIsoData(solicitacaoToEdit.dataSolicitacao),
        dataConclusao: convertIsoData(solicitacaoToEdit.dataConclusao),
        celula_id: 3,
      });
    }
  }, [isEditing]);

  const getProcesso = () => {
    if (formData?.processo?.length == 25) {
      const keys = Object.keys(formData || {});
      const convert = {};
      const found = indicacao.find(
        (ind) => ind?.processo?.trim() === formData?.processo?.trim(),
      );

      Object.keys(found || {}).forEach((e) => {
        if (keys.includes(e)) {
          if (e != "status") {
            convert[e] = found[e];
          }
        }
      });
      if (found) {
        setFoundIndicacao(found)
        setFormData({ ...formData, ...convert });
      }
    }
  }

  useEffect(() => {
    if (dataPrevista) {
      dataPrevistaRef.current.focus();
    }
  }, [dataPrevista]);

  return (
    <div
      className={`bg-[rgb(249 250 251)] xl:w-[50%] m-auto ${isEditing && "!w-[100%] xl:!w-[100%]"}`}
    >
      <div class="text-center my-8">
        <h1 class="text-3xl md:text-4xl font-semibold text-gray-900">
          {isEditing ? "Editar" : "Criar uma nova"} Solicitação
        </h1>
        <p class="mt-2 text-gray-700">
          Preencha os dados abaixo para solicitar uma nova avaliação de imóvel para leilão.
        </p>

      </div>

      <div className="w-full sm:w-3/4 md:w-1/2 lg:w-[60%] m-auto text-black">


        <form
          className="!grid !grid-cols-2 gap-5"
          onSubmit={isEditing ? handleEdit : handleSubmit}
        >
          {/* <h2 className="text-white text-xl bg-black p-4 rounded-t-lg">
          {isEditing ? "Editar" : "Criar"} Solicitação
        </h2> */}

          <div className="relative w-full">
            <select
              id="departamento_id"
              name="departamento_id"
              value={formData.departamento_id}
              onChange={handleChange}
              required
              className="peer w-full appearance-none rounded-xl border border-gray-300 bg-white px-4 pt-6 pb-2 text-sm text-gray-900
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
            >
              <option value="">Selecione o departamento</option>
              <option value="4">Comercial</option>
              <option value="2">Jurídico</option>
              <option value="3">Estratégico</option>
              <option value="5">Marketing</option>
              <option value="1">Administrativo</option>
              <option value="6">Recuperação Extrajudicial</option>
              <option value="7">Nenhum</option>
            </select>

            <label
              htmlFor="departamento_id"
              className={`absolute left-4 text-sm text-gray-500  px-1 transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${formData?.departamento_id ? 'top-2 text-sm' : 'top-2'}
    `}
            >
              Departamento
            </label>

            {/* Ícone de seta */}
            <svg
              className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </div>


          <div className="relative w-full">
            <select
              id="setor_id"
              name="setor_id"
              value={formData.setor_id}
              onChange={handleChange}
              required
              className="peer w-full appearance-none rounded-xl border border-gray-300 bg-white px-4 pt-6 pb-2 text-sm text-gray-900
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
            >
              <option value="">Selecione o setor</option>
              <option value="2">Negócios</option>
              <option value="1">Captação</option>
              <option value="3">Api</option>
              <option value="4">Controladoria</option>
              <option value="5">Editais</option>
              <option value="6">Encerramentos</option>
              <option value="7">Publicação</option>
              <option value="8">Financeiro</option>
              <option value="9">Departamento Pessoal</option>
              <option value="10">Infraestrutura</option>
              <option value="11">Nenhum</option>
            </select>

            <label
              htmlFor="setor_id"
              className={`absolute left-4 text-sm text-gray-500 transition-all duration-200
              peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
              peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
              ${formData?.setor_id ? 'top-2 text-sm ' : 'top-2'}
    `}
            >
              Setor
            </label>

            {/* Ícone da seta */}
            <svg
              className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </div>


          <div className="relative w-full">
            <select
              id="celula_id"
              name="celula_id"
              value={formData.celula_id}
              onChange={handleChange}
              required
              className="peer w-full appearance-none rounded-xl border border-gray-300 bg-white px-4 pt-6 pb-2 text-sm text-gray-900
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
            >
              <option value="">Selecione a célula</option>
              <option value="3">Avaliação</option>
              <option value="1">Tecnologia</option>
              <option value="2">Prospecção</option>
              <option value="4">Cadastro</option>
              <option value="5">Atendimento</option>
              <option value="6">Mediata</option>
              <option value="7">Imediata</option>
              <option value="8">Nenhuma</option>
            </select>

            <label
              htmlFor="celula_id"
              className={`absolute left-4 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${formData?.celula_id ? 'top-2 text-sm text-blue-500' : 'top-4'}
    `}
            >
              Célula
            </label>

            {/* Ícone de seta */}
            <svg
              className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </div>


          {formData.celula_id == 3 && (
            <>
              <div className="flex items-center justify-center w-full">
                <label
                  className={`
                  flex items-center justify-center gap-3 w-full max-w-xs rounded-lg border p-3 mt-[-10px] text-center
                  transition-all cursor-pointer
                  ${dataPrevista ? "bg-black text-white font-semibold" : "bg-white text-gray-600 border-gray-400 hover:bg-gray-600 hover:text-white"}
        `}
                >
                  Data Prevista
                  <input
                    type="checkbox"
                    name="dataPrevista"
                    checked={dataPrevista}
                    onChange={() => setDataPrevista(!dataPrevista)}
                    className="hidden"
                  />
                </label>
              </div>

              {dataPrevista ? (
                <div className="relative w-full max-w-sm">
                  <input
                    type="date"
                    id="dataConclusao"
                    name="dataConclusao"
                    ref={dataPrevistaRef}
                    value={formData.dataConclusao}
                    onChange={handleChange}
                    className="peer w-full rounded-xl border bg-white !px-4 !pt-5 !pb-2 text-gray-900
        focus:outline-none focus:ring-2 focus:ring-blue-500
        disabled:bg-gray-100 disabled:cursor-not-allowed"
                    placeholder=" " // necessário para o label flutuante
                  />
                  <label
                    htmlFor="dataConclusao"
                    className={`absolute left-4 top-2 text-sm text-black transition-all duration-200
        peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
        peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
        ${formData.dataConclusao ? 'top-2 text-sm' : ''}
      `}
                  >
                    Data Prevista
                  </label>
                </div>
              ) : (
                <div className="relative w-full max-w-sm">
                  <input
                    type="date"
                    id="dataSolicitacao"
                    name="dataSolicitacao"
                    value={formData.dataSolicitacao}
                    onChange={handleChange}
                    className="peer w-full rounded-xl border bg-white !px-4 !pt-5 !pb-2 text-gray-900
        focus:outline-none focus:ring-2 focus:ring-blue-500
        disabled:bg-gray-100 disabled:cursor-not-allowed"
                    placeholder=" " // necessário para o label flutuante
                  />
                  <label
                    htmlFor="dataSolicitacao"
                    className={`absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
        peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
        peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
        ${formData.dataSolicitacao ? 'top-2 text-sm' : ''}
      `}
                  >
                    Data da Solicitação
                  </label>
                </div>
              )}

              <div className="relative w-full max-w-sm">
                <input
                  type="text"
                  id="processo"
                  name="processo"
                  onBlur={getProcesso}
                  value={formData.processo}
                  onChange={handleChange}
                  placeholder=" " // necessário para o label flutuante
                  className="peer w-full rounded-xl border bg-white px-4 pt-5 pb-2 text-gray-900
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
                />
                <label
                  htmlFor="processo"
                  className={`absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${formData.processo ? 'top-2 text-sm' : ''}
    `}
                >
                  Processo
                </label>
              </div>

              <div className="relative w-full max-w-sm">
                <input
                  type="text"
                  id="diretorio"
                  name="diretorio"
                  value={formData.diretorio}
                  onChange={handleChange}
                  placeholder=" " // necessário para o label flutuante
                  className="peer w-full rounded-xl border bg-white px-4 pt-5 pb-2 text-gray-900
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
                />
                <label
                  htmlFor="diretorio"
                  className={`absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${formData.diretorio ? 'top-2 text-sm' : ''}
    `}
                >
                  Diretório
                </label>
              </div>

              <div className="relative w-full max-w-sm">
                <input
                  type="text"
                  id="vara"
                  name="vara"
                  value={formData.vara}
                  onChange={handleChange}
                  placeholder=" " // necessário para label flutuante
                  className="peer w-full rounded-xl border bg-white px-4 pt-5 pb-2 text-gray-900
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
                />
                <label
                  htmlFor="vara"
                  className={`absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${formData.vara ? 'top-2 text-sm' : ''}
    `}
                >
                  Vara
                </label>
              </div>

              <div className="relative w-full max-w-sm">
                <input
                  type="text"
                  id="foro"
                  name="foro"
                  value={formData.foro}
                  onChange={handleChange}
                  placeholder=" " // placeholder vazio para o label flutuar
                  className="peer w-full rounded-xl border bg-white px-4 pt-5 pb-2 text-gray-900
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
                />
                <label
                  htmlFor="foro"
                  className={`absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${formData.foro ? 'top-2 text-sm' : ''}
    `}
                >
                  Foro
                </label>
              </div>

              <div className="relative w-full max-w-sm">
                <input
                  type="text"
                  id="juizo"
                  name="juizo"
                  value={formData.juizo}
                  onChange={handleChange}
                  placeholder=" " // placeholder vazio para label flutuar
                  className="peer w-full rounded-xl border bg-white px-4 pt-5 pb-2 text-gray-900
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
                />
                <label
                  htmlFor="juizo"
                  className={`absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${formData.juizo ? 'top-2 text-sm' : ''}
    `}
                >
                  Juiz
                </label>
              </div>

              <div className="relative w-full max-w-sm">
                <input
                  type="text"
                  id="dadosExequente"
                  name="dadosExequente"
                  value={formData.dadosExequente}
                  onChange={handleChange}
                  placeholder=" " // placeholder vazio para label flutuar
                  className="peer w-full rounded-xl border bg-white px-4 pt-5 pb-2 text-gray-900
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
                />
                <label
                  htmlFor="dadosExequente"
                  className={`absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${formData.dadosExequente ? 'top-2 text-sm' : ''}
    `}
                >
                  Dados do Exequente
                </label>
              </div>

             

  {/* Nome do Exequente */}
  <div className="relative w-full">
  <input
    id="nomeSolicitante"
    type="text"
    name="nomeSolicitante"
    value={formData.nomeSolicitante}
    onChange={handleChange}
    placeholder=" "
   className="peer w-full rounded-xl border bg-white px-4 pt-5 pb-2 text-gray-900
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
  />
  <label
    htmlFor="nomeSolicitante"
    className="absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500 pointer-events-none"
  >
    Nome do Exequente
  </label>
</div>


  {/* CPF ou CNPJ */}
 <div className="relative w-full">
  <input
    id="documentoSolicitante"
    type="text"
    name="documentoSolicitante"
    value={formData.documentoSolicitante}
    onChange={handleChange}
    placeholder=" "
    className="peer w-full rounded-xl border border-gray-300 bg-white px-4 pt-6 pb-2 text-gray-900
      focus:outline-none focus:ring-2 focus:ring-blue-500"
  />
  <label
    htmlFor="documentoSolicitante"
    className="absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500 pointer-events-none"
  >
    CPF ou CNPJ do Exequente
  </label>
</div>


  {/* Endereço */}
  <div className="relative w-full">
  <input
    id="enderecoSolicitante"
    type="text"
    name="enderecoSolicitante"
    value={formData.enderecoSolicitante}
    onChange={handleChange}
    placeholder=" "
    className="peer w-full rounded-xl border border-gray-300 bg-white px-4 pt-6 pb-2 text-gray-900
      focus:outline-none focus:ring-2 focus:ring-blue-500"
  />
  <label
    htmlFor="enderecoSolicitante"
    className="absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500 pointer-events-none"
  >
    Endereço do Exequente
  </label>
</div>


  {/* Advogado */}
  <div className="relative w-full">
  <input
    type="text"
    id="advogado"
    name="advogado"
    value={formData.advogado}
    onChange={handleChange}
    placeholder=" "
    className="peer w-full rounded-xl border bg-white px-4 pt-6 pb-2 text-gray-900 
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
  />
  <label
    htmlFor="advogado"
    className="absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500 pointer-events-none"
  >
    Advogado
  </label>
</div>


  {/* Estado */}
 <div className="relative w-full">
  <select
    name="estado"
    id="estado"
    value={formData.estado}
    onChange={handleChange}
    className="peer w-full appearance-none rounded-xl border bg-white px-4 pt-6 pb-2 text-gray-900
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
  >
    <option value="" disabled hidden></option>
    <option value="São Paulo">São Paulo</option>
    <option value="Outros">Outros</option>
  </select>

  <label
    htmlFor="estado"
    className="absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500 pointer-events-none"
  >
    Estado
  </label>

  <svg
    className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M5.23 7.21a.75.75 0 011.06.02L10 10.939l3.71-3.71a.75.75 0 111.06 1.061l-4.24 4.24a.75.75 0 01-1.06 0l-4.24-4.24a.75.75 0 01.02-1.06z"
      clipRule="evenodd"
    />
  </svg>
</div>



  {/* Prioridade */}
  <div className="relative w-full">
  <select
    name="prioridade"
    disabled={dataPrevista}
    value={formData.prioridade}
    onChange={handleChange}
    className="peer w-full appearance-none rounded-xl border bg-white px-4 pt-6 pb-2 text-gray-900
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
  >
    <option value="" disabled hidden></option>
    {formData.estado === "São Paulo" ? (
      <>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
      </>
    ) : (
      <>
        <option value="1">1</option>
        <option value="2">2</option>
      </>
    )}
  </select>

  <label
    htmlFor="prioridade"
    className="absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500 pointer-events-none"
  >
    Prioridade
  </label>

  <svg
    className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M5.23 7.21a.75.75 0 011.06.02L10 10.939l3.71-3.71a.75.75 0 111.06 1.061l-4.24 4.24a.75.75 0 01-1.06 0l-4.24-4.24a.75.75 0 01.02-1.06z"
      clipRule="evenodd"
    />
  </svg>
</div>


  {/* Data de conclusão */}
 <div className="relative w-full">
  <input
    type="text"
    name="dataConclusao"
    disabled={true}
    value={formData.dataConclusao?.split("-").reverse().join("/") || ""}
    onChange={handleChange}
    placeholder=" "
    className="peer w-full rounded-xl border bg-gray-100 px-4 pt-6 pb-2 text-gray-900 
      disabled:cursor-not-allowed 
      focus:outline-none focus:ring-2 focus:ring-blue-500"
  />
  <label
    htmlFor="dataConclusao"
    className="absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500 pointer-events-none"
  >
    Data de conclusão
  </label>
</div>


  {/* Status */}
  <div className="relative w-full">
  <select
    disabled={!isEditing}
    name="status"
    value={formData.status}
    onChange={handleChange}
    className="peer w-full appearance-none rounded-xl border bg-white px-4 pt-6 pb-2 text-gray-900
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
  >
    <option value="Pendente">Pendente</option>
    {usuario.role.includes("Captação") && (
      <>
        <option value="Enviado">Enviado</option>
        <option value="Rejeitado">Rejeitado</option>
        <option value="Concluído">Concluído</option>
      </>
    )}
    {usuario.role.includes("Avaliação") && (
      <>
        <option value="Concluído">Concluído</option>
        <option value="Prejudicado">Prejudicado</option>
        <option value="Correção">Correção</option>
        <option value="Realizado">Realizado</option>
      </>
    )}
  </select>
  <label
    htmlFor="status"
    className="absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500 pointer-events-none"
  >
    Status
  </label>
  {/* Ícone da seta */}
  <div className="pointer-events-none absolute right-4 top-5 text-gray-500">
    ▼
  </div>
</div>

  {/* Tipo da solicitação */}
  <div className="relative w-full">
  <select
    required
    name="tipoSolicitacao"
    value={formData.tipoSolicitacao}
    onChange={handleChange}
    className="peer w-full appearance-none rounded-xl border bg-white px-4 pt-6 pb-2 text-gray-900
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
  >
    <option value="">Selecione o tipo da solicitação</option>
    <option value="Relatórios Comparativos + Pareceres">Relatórios Comparativos + Pareceres</option>
    <option value="Pareceres técnicos">Pareceres técnicos</option>
    <option value="Análise de Matrícula">Análise de Matrícula</option>
    <option value="Análise de Precificação">Análise de Precificação</option>
    <option value="Busca de Bens">Busca de Bens</option>
    <option value="Emissão de documentos">Emissão de documentos</option>
    <option value="Avaliação Extrajudiciais">Avaliação Extrajudiciais</option>
    <option value="Sem tipo">Sem tipo</option>
  </select>

  <label
    htmlFor="tipoSolicitacao"
    className="absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500 pointer-events-none"
  >
    Tipo da solicitação
  </label>

  {/* Ícone SVG da seta */}
  <div className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-gray-500">
    <svg
      className="h-4 w-4"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  </div>
</div>

  {/* Link do Relatório (condicional) */}
  {isEditing && formData.status === 'Realizado' &&
    (usuario.role.includes('Supervisor') || usuario.role.includes('Avaliação')) && (
      <label>
        <p>Link do Relatório</p>
        <input
          type="text"
          name="link_relatorio"
          value={formData.link_relatorio}
          onChange={handleChange}
          placeholder="Link do Relatório"
        />
      </label>
  )}

  {/* Número de relatórios (condicional) */}
  {isEditing && formData.status === 'Realizado' && (
    <label>
      <p>Quantos relatórios foram gerados</p>
      <input
        type="number"
        name="relatorios_gerados"
        value={formData.relatorios_gerados}
        onChange={handleChange}
        placeholder="Número de relatórios gerados"
        required
      />
    </label>
  )}

  {/* Motivo de rejeição (condicional) */}
  {formData.status === "Rejeitado" && !page && (
    <label className="flex flex-col gap-3 col-span-2">
      <p>Descreva o motivo da rejeição:</p>
      <textarea
        required
        minLength={1}
        name="motivo_rejeicao"
        onChange={handleChange}
        value={formData.motivo_rejeicao}
      />
    </label>
  )}






              <div className="relative w-full max-w-sm">
                <input
                  type="text"
                  id="num_matricula"
                  name="num_matricula"
                  value={formData.num_matricula}
                  onChange={handleChange}
                  placeholder=" " // necessário para label flutuante
                  className="peer w-full rounded-xl border bg-white px-4 pt-5 pb-2 text-gray-900 
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
                />
                <label
                  htmlFor="num_matricula"
                  className={`absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${formData.num_matricula ? 'top-2 text-sm' : ''}
    `}
                >
                  Número da Matrícula
                </label>
              </div>


              <div className="relative w-full max-w-sm">
                <input
                  type="text"
                  id="cartorio"
                  name="cartorio"
                  value={formData.cartorio}
                  onChange={handleChange}
                  placeholder=" " // necessário para ativar o efeito flutuante
                  className="peer w-full rounded-xl border bg-white px-4 pt-5 pb-2 text-gray-900 
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
                />
                <label
                  htmlFor="cartorio"
                  className={`absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${formData.cartorio ? 'top-2 text-sm' : ''}
    `}
                >
                  Cartório
                </label>
              </div>


              <div className="relative w-full max-w-sm">
                <textarea
                  id="dadosDoImovel"
                  name="dadosDoImovel"
                  value={formData.dadosDoImovel}
                  onChange={handleChange}
                  placeholder=" " // necessário para ativar label flutuante
                  className="peer w-full rounded-xl border bg-white px-4 pt-5 pb-2 text-gray-900 
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed resize-none min-h-[56px]"
                  rows={1} // inicia com 1 linha, mas não cresce por causa do resize-none
                />
                <label
                  htmlFor="dadosDoImovel"
                  className={`absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${formData.dadosDoImovel ? 'top-2 text-sm' : ''}
    `}
                >
                  Dados do Imóvel
                </label>
              </div>



              <div className="relative w-full max-w-sm">
                <select
                  id="tipoBem"
                  name="tipoBem"
                  value={formData.tipoBem}
                  onChange={handleChange}
                  className="peer w-full appearance-none rounded-xl border bg-white px-4 pt-5 pb-2 text-gray-900
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
                >
                  <option value=""></option>
                  <option value="movel">Móvel</option>
                  <option value="imovel">Imóvel</option>
                  <option value="semovente">Semovente</option>
                </select>

                <label
                  htmlFor="tipoBem"
                  className={`absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${formData.tipoBem ? 'top-2 text-sm' : ''}
    `}
                >
                  Tipo de bem
                </label>

                {/* Seta personalizada */}
                <div className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-gray-500">
                  ▼
                </div>
              </div>

              <div className="relative w-full max-w-sm">
                <select
                  id="estado"
                  name="estado"
                  value={formData.estado}
                  onChange={handleChange}
                  className="peer w-full appearance-none rounded-xl border bg-white px-4 pt-5 pb-2 text-gray-900 
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
                >
                  <option value="">Selecione o Estado</option>
                  <option value="São Paulo">São Paulo</option>
                  <option value="Outros">Outros</option>
                </select>
                <label
                  htmlFor="estado"
                  className={`absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${formData.estado ? 'top-2 text-sm' : ''}
    `}
                >
                  Estado
                </label>

                {/* Seta do select */}
                <div className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-gray-400">
                  ▼
                </div>
              </div>

              <div className="relative w-full max-w-sm">
                <select
                  id="prioridade"
                  name="prioridade"
                  value={formData.prioridade}
                  onChange={handleChange}
                  className="peer w-full appearance-none rounded-xl border bg-white px-4 pt-5 pb-2 text-gray-900 
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
                >
                  <option value="">Selecione a Prioridade</option>
                  {formData.estado === "São Paulo" ? (
                    <>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                    </>
                  ) : (
                    <>
                      <option value="1">1</option>
                      <option value="2">2</option>
                    </>
                  )}
                </select>
                <label
                  htmlFor="prioridade"
                  className={`absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${formData.prioridade ? 'top-2 text-sm' : ''}
    `}
                >
                  Prioridade
                </label>

                {/* Seta personalizada */}
                <div className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-gray-400">
                  ▼
                </div>
              </div>

              <div className="relative w-full max-w-sm">
                <input
                  id="dataConclusao"
                  type="text"
                  name="dataConclusao"
                  disabled
                  value={formData.dataConclusao?.split("-").reverse().join("/") || ""}
                  onChange={handleChange}
                  placeholder=" "
                  className="peer w-full rounded-xl border bg-gray-100 px-4 pt-5 pb-2 text-gray-900 
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:cursor-not-allowed"
                />
                <label
                  htmlFor="dataConclusao"
                  className={`absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${formData.dataConclusao ? 'top-2 text-sm' : ''}
    `}
                >
                  Data de Conclusão
                </label>
              </div>

              <div className="relative w-full max-w-sm">
                <select
                  id="status"
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                  disabled={!isEditing}
                  className="peer w-full rounded-xl border bg-white px-4 pt-7 pb-2 text-gray-900 
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
                >
                  <option value="Pendente">Pendente</option>
                  {usuario.role.includes("Captação") && (
                    <>
                      <option value="Enviado">Enviado</option>
                      <option value="Rejeitado">Rejeitado</option>
                      <option value="Concluído">Concluído</option>
                    </>
                  )}
                  {usuario.role.includes("Avaliação") && (
                    <>
                      <option value="Concluído">Concluído</option>
                      <option value="Prejudicado">Prejudicado</option>
                      <option value="Correção">Correção</option>
                      <option value="Realizado">Realizado</option>
                    </>
                  )}
                </select>

                <label
                  htmlFor="status"
                  className={`absolute left-5 text-sm text-gray-500 transition-all duration-200
      peer-placeholder-shown:top-7 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${formData.status ? 'top-2 text-sm text-blue-500' : ''}`}
                >
                  Status
                </label>
              </div>


              <div className="relative w-full col-span-2">
                <select
                  id="tipoSolicitacao"
                  name="tipoSolicitacao"
                  value={formData.tipoSolicitacao}
                  onChange={handleChange}
                  required
                  className="peer w-full rounded-xl border bg-white px-4 pt-7 pb-2 text-gray-900 
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
                >
                  <option value="">Selecione o tipo da solicitação</option>
                  <option value="Relatórios Comparativos + Pareceres">
                    Relatórios Comparativos + Pareceres
                  </option>
                  <option value="Pareceres técnicos">Pareceres técnicos</option>
                  <option value="Análise de Matrícula">Análise de Matrícula</option>
                  <option value="Análise de Precificação">Análise de Precificação</option>
                  <option value="Busca de Bens">Busca de Bens</option>
                  <option value="Emissão de documentos">Emissão de documentos</option>
                  <option value="Avaliação Extrajudiciais">Avaliação Extrajudiciais</option>
                  <option value="Sem tipo">Sem tipo</option>
                </select>

                <label
                  htmlFor="tipoSolicitacao"
                  className={`absolute left-5 text-sm text-gray-500 transition-all duration-200
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${formData.tipoSolicitacao ? 'top-2 text-sm text-blue-500' : 'top-2 text-base text-gray-400'}`}
                >
                  Tipo da solicitação
                </label>
              </div>



              {(isEditing && formData.status === 'Realizado' && (usuario.role.includes('Supervisor') || usuario.role.includes('Avaliação'))) && (
                <label className="flex flex-col gap-2">
                  <p>Link do Relatório</p>
                  <input
                    type="text"
                    name="link_relatorio"
                    value={formData.link_relatorio}
                    onChange={handleChange}
                    placeholder="Link do Relatório"
                    className="p-3 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </label>
              )}

              {(formData.status === "Rejeitado" && !page) && (
                <label className="flex flex-col gap-2 col-span-2">
                  <p>Descreva o motivo da rejeição:</p>
                  <textarea
                    required
                    minLength={1}
                    name="motivo_rejeicao"
                    onChange={handleChange}
                    value={formData.motivo_rejeicao}
                    className="p-3 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 resize-y"
                    rows={4}
                  />
                </label>
              )}

              {(formData.status === "Prejudicado" && page === 'av' && !solicitacaoToEdit.data_entrega) && (
                <label className="flex flex-col gap-2 col-span-2">
                  <p>Justifique o motivo:</p>
                  <textarea
                    required
                    minLength={1}
                    name="justificativa_avaliacao"
                    onChange={handleChange}
                    value={formData.justificativa_avaliacao}
                    className="p-3 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 resize-y"
                    rows={4}
                  />
                </label>
              )}


              <div className=" !w-[100%] col-span-2 ">
                <button
                  className="bg-black text-white  py-3 px-11 hover:bg-gray-700 !w-[100%]"
                  type="submit"
                >
                  Enviar
                </button>
              </div>
            </>
          )}
        </form>
      </div>
    </div>
  );
}

export default SolicitacaoesCaptacaoAvaliacao;
